import auth0 from 'auth0-js'
import { computed, reactive } from 'vue'

const domain = window.location.hostname.split('.').reverse().splice(0, 2).reverse().join('.')

// let client
const state = reactive({
  loading: false,
  isAuthenticated: false,
  error: null,
  token: null
})

/* eslint-disable-next-line */
const token = document.cookie.replace(/(?:(?:^|.*;\s*)op_forecasting_cookie_auth0\s*\=\s*([^;]*).*$)|^.*$/, '$1')
state.token = token

const authConfig = {
  domain: 'ragnorak.auth0.com',
  clientID: 'UM37h1028DNxfKYVpAIMjZ6DjfSuWgAT',
  responseType: 'token'
}

const webAuth = new auth0.WebAuth(authConfig)

function login (token) {
  state.token = token
  document.cookie = `op_forecasting_cookie_auth0=${token};path=/;domain=${domain};expires=Fri, 31 Dec 9999 23:59:59 GMT`
  state.isAuthenticated = true
}

function logout () {
  removeToken()
  state.isAuthenticated = false
}

async function authenticate (token) {
  state.loading = true
  await webAuth.client.userInfo(token, (error) => {
    if (error) {
      state.loading = false
      removeToken()
    } else {
      state.isAuthenticated = true
      state.loading = false
    }
  })
}

function removeToken () {
  document.cookie = `op_forecasting_cookie_auth0=;path=/;domain=${domain};expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

const authPlugin = {
  isAuthenticated: computed(() => state.isAuthenticated),
  loading: computed(() => state.loading),
  token: computed(() => state.token),
  login,
  logout,
  webAuth,
  authenticate
}


export const setupAuth = async () => {
  return {
    install: (app) => {
      app.config.globalProperties.$auth = authPlugin
    }
  }
}
